import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Sirve para cualquier tipo de negocio?',
    a: 'Sí. Los prompts están diseñados para adaptarse a e-commerce, servicios, infoproductos, coaching, restaurantes, clínicas y cualquier negocio que invierta en Meta Ads. Cada prompt incluye instrucciones de personalización por tipo de negocio.'
  }, {
    q: '¿Cómo recibo el material?',
    a: '100% digital. Apenas confirmado el pago, recibís un email con el acceso a todos los PDFs en menos de 5 minutos. Sin esperas. Sin envíos físicos.'
  }, {
    q: '¿Funciona con ChatGPT gratuito?',
    a: 'Sí. Todos los prompts son compatibles con ChatGPT 3.5 (gratuito), ChatGPT 4, Claude y Gemini. El sistema está diseñado para funcionar con cualquier IA disponible hoy.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí, y es de las pocas que realmente se cumple. 7 días, devolución completa, sin preguntas. Podés escribirnos a soporte.tumanualdigital@gmail.com y procesamos el reembolso el mismo día.'
  }, {
    q: '¿Es solo para expertos en Meta Ads?',
    a: 'No. El sistema está diseñado para tres perfiles: el que empieza (encuentra estructura inmediata), el que ya trabaja (encuentra velocidad y mejores resultados) y el que quiere escalar (encuentra el sistema para pasar al siguiente nivel).'
  }];
  return <section className="py-14 px-4 max-w-3xl mx-auto" data-id="element-113">
      <FadeIn data-id="element-114">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-10 flex items-center justify-center gap-3" data-id="element-115">
          <span className="text-4xl" data-id="element-116">❓</span> LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-4" data-id="element-117">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} data-id="element-118" />)}
        </div>
      </FadeIn>
    </section>;
}
function FAQItem({
  question,
  answer
}: {
  question: string;
  answer: string;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-gray-800 rounded-xl bg-gray-900/50 overflow-hidden" data-id="element-119">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-120">
        <span className="font-bold text-lg text-gray-200" data-id="element-121">{question}</span>
        <ChevronDown className={`text-green-500 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} size={20} data-id="element-122" />
      </button>
      <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-123">
        <p className="text-gray-400 leading-relaxed" data-id="element-124">{answer}</p>
      </div>
    </div>;
}